'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { FETCHED_VIDEO_MAP } from '../actions/ActionTypes';
import { receiveVideoMap, requestedVideoMapFailed, requestVideoMap } from '../actions/VideoActions';
export default ((action$, _, {
  IndexerClient
}) => action$.ofType(FETCHED_VIDEO_MAP).pipe(switchMap(({
  payload: {
    contentPageId
  }
}) => IndexerClient.fetchContentVideos(contentPageId).pipe(map(receiveVideoMap), catchError(error => of(requestedVideoMapFailed(error))), startWith(requestVideoMap())))));